import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Kunde:", -1)
const _hoisted_3 = {
  key: 1,
  class: "w-full h-full bg-zewotherm-lightgrey rounded-l-lg flex flex-col outline-none p-2"
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "w-full flex" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 2,
  class: "h-full w-10 bg-zewotherm-lightgrey rounded-r-lg flex items-center justify-center"
}
const _hoisted_8 = {
  key: 0,
  class: "w-full min-h-52 h-52 bg-zewotherm-lightgrey rounded-lg p-2 flex flex-col overflow-y-auto"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "w-full flex" }
const _hoisted_12 = { key: 0 }

import { onMounted, Ref, ref, watch } from 'vue'
import { useAddProject } from '@/store/addProject'
import { closeCircle } from 'ionicons/icons'
import { IonIcon, IonSelect, IonSelectOption } from '@ionic/vue'
import axios from 'axios'
import { useCompany } from '@/store/company'
import Customer from '@/interfaces/customer/Customer'
import { useUsers } from '@/store/users'
import User from '@/interfaces/User'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInput',
  setup(__props) {

const addProjectStore = useAddProject()
const companyStore = useCompany()
const userStore = useUsers()
const searchCustomer = ref("")
const customersToChoose: Ref<Customer[]> = ref([])
const currentUserStore = useCurrentUser()

watch(() => searchCustomer.value, async(newValue, oldValue) => {
  if(newValue.length >= 3) {
    const response = await axios.get(process.env.VUE_APP_CUSTOMER_API_BASE_URL + "customer/?search=" + newValue + "&company_id=" + addProjectStore.activeCompanyForCustomers, {
      headers: {
        Authorization: 'Bearer ' + currentUserStore.jwtKey
      }
    })
    customersToChoose.value = response.data.data
    for(let customer of customersToChoose.value) {
      if(customer.sales_user) customer.sales_user_text = getAUser(customer.sales_user.toString())
    }
  } else {
    customersToChoose.value = []
  }
})

function getAUser(userId: string): string {
  const currentUser = userStore.users.find((user: User) =>user.id.toString() == userId)
  if(!currentUser) return ""
  return currentUser.first_name + " " + currentUser.last_name
}

function clearCustomer() {
  addProjectStore.setProjectActiveDataCustomer(null, currentUserStore.jwtKey)
}

function setCustomer(customer: Customer) {
  addProjectStore.setProjectActiveDataCustomer(customer, currentUserStore.jwtKey)
  customersToChoose.value = []
  searchCustomer.value = ""
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-row min-h-min h-10 rounded-lg my-1", [_unref(addProjectStore).errorResponse.customer && _unref(addProjectStore).errorResponse.customer.length > 0 ? 'border-2 border-red-500' : '']])
    }, [
      (_unref(addProjectStore).projectActiveData.customer == null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            enterkeyhint: "next",
            class: _normalizeClass(["w-full h-full flex placeholder-zewotherm-grey bg-zewotherm-lightgrey font-bold outline-none", [_unref(addProjectStore).projectActiveData.customer == null ? 'rounded-lg' : 'rounded-l-lg']])
          }, [
            (_unref(companyStore).activeCompany.id == 17 || _unref(companyStore).activeCompany.id == 14)
              ? (_openBlock(), _createBlock(_unref(IonSelect), {
                  key: 0,
                  modelValue: _unref(addProjectStore).activeCompanyForCustomers,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(addProjectStore).activeCompanyForCustomers) = $event)),
                  enterkeyhint: "next",
                  class: "w-auto h-full placeholder-zewotherm-grey p-2 bg-zewotherm-lightgrey font-bold rounded-l-lg outline-none"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyStore).allCompanies, (company, index) => {
                      return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                        value: company.id.toString(),
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(company.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              placeholder: "Suche",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchCustomer).value = $event)),
              class: _normalizeClass(["w-0 flex-grow h-full placeholder-zewotherm-grey p-2 bg-zewotherm-lightgrey font-bold outline-none", [_unref(companyStore).activeCompany.id == 17 || _unref(companyStore).activeCompany.id == 14 ? 'rounded-r-lg' : 'rounded-lg']])
            }, null, 2), [
              [_vModelText, searchCustomer.value]
            ])
          ], 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(addProjectStore).projectActiveData.customer?.name1), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", null, _toDisplayString(_unref(addProjectStore).projectActiveData.customer?.cid) + " - ", 1),
              (_unref(addProjectStore).projectActiveData.customer!.sales_user_text)
                ? (_openBlock(), _createElementBlock("label", _hoisted_6, _toDisplayString(_unref(addProjectStore).projectActiveData.customer?.sales_user_text) + " - ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("label", null, _toDisplayString(_unref(addProjectStore).projectActiveData.customer?.city) + ", " + _toDisplayString(_unref(addProjectStore).projectActiveData.customer?.country), 1)
            ])
          ])),
      (_unref(addProjectStore).projectActiveData.customer != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(IonIcon), {
              icon: _unref(closeCircle),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (clearCustomer())),
              class: "w-6 h-6 cursor-pointer"
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (customersToChoose.value.length >= 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customersToChoose.value, (customer, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w-full h-20 rounded flex flex-col my-2 first:mt-0 last:mb-0 p-1",
              onClick: ($event: any) => (setCustomer(customer)),
              key: index
            }, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(customer.name1), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", null, _toDisplayString(customer.cid) + " - ", 1),
                (customer.sales_user_text)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, _toDisplayString(customer.sales_user_text) + " - ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("label", null, _toDisplayString(customer.city) + ", " + _toDisplayString(customer.country), 1)
              ])
            ], 8, _hoisted_9))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.customer, (errorMsg, index) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "text-red-500",
        key: index
      }, _toDisplayString(errorMsg), 1))
    }), 128))
  ]))
}
}

})